var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueprint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.923,
    height: 19.55,
    viewBox: "0 0 16.923 19.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    transform: "translate(-3.237 -0.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12051",
    "data-name": "Group 12051",
    transform: "translate(3.237 0.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12048",
    "data-name": "Group 12048"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1431",
    "data-name": "Rectangle 1431",
    width: 3.956,
    height: 2.895,
    fill: "#37bdb0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1432",
    "data-name": "Rectangle 1432",
    width: 3.956,
    height: 1.016,
    transform: "translate(0 4.853)",
    fill: "#37bdb0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1433",
    "data-name": "Rectangle 1433",
    width: 3.956,
    height: 12.642,
    transform: "translate(0 6.893)",
    fill: "#37bdb0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12049",
    "data-name": "Group 12049",
    transform: "translate(5.873 1.917)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1434",
    "data-name": "Rectangle 1434",
    width: 3.059,
    height: 3.953,
    fill: "#37bdb0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1435",
    "data-name": "Rectangle 1435",
    width: 3.059,
    height: 11.664,
    transform: "translate(0 5.955)",
    fill: "#37bdb0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12050",
    "data-name": "Group 12050",
    transform: "translate(9.791 1.448)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1436",
    "data-name": "Rectangle 1436",
    width: 3.952,
    height: 4.935,
    transform: "translate(4.895 0) rotate(82.704)",
    fill: "#37bdb0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1437",
    "data-name": "Rectangle 1437",
    width: 11.664,
    height: 4.935,
    transform: "translate(2.237 18.103) rotate(-97.291)",
    fill: "#37bdb0"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueprint);
export default __webpack_public_path__ + "static/media/Blueprint.d5056cf9c3b6e53abe864da2bfd0e20e.svg";
export { ForwardRef as ReactComponent };